import { InputType } from "~/scad-shared/types/generic";
import { getControlTypeMapping } from "~/scad-shared/config";

export function deriveTypeFromControlType(controlType: string) {
  const mainControlType = controlType.split(":")[0];

  switch (mainControlType) {
    case "select":
    case "tableselect":
    case "queryselect":
    case "enumselect":
    case "number":
    case "integer":
    case "percent":
    case "currency":
    case "decimal":
    case "month":
    case "year":
      return "number";
    case "textselect":
    case "text":
      return "string";
    case "date":
      return "date";
    case "datetime":
      return "datetime";
    case "checkbox":
      return "bool";
    case "multiselect":
      return "array";
    default:
      return "string";
  }
}

/**
 * Converts a control type string to an InputType enum value.
 * Uses the configurable control type mapping.
 *
 * @param controlType - The control type string from metadata
 * @returns The corresponding InputType enum value
 */
export function controlTypeToInputType(controlType: string): InputType {
  const mapping = getControlTypeMapping();
  const key = controlType as keyof typeof mapping;

  if (key in mapping) {
    return mapping[key];
  }

  return mapping["default"] || InputType.InputText;
}
